export default __webpack_public_path__ + "static/media/rug15-min.440976df.jpg";